import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { LayoutDashboard, Zap, ShieldCheck, BarChart3, Database, Workflow } from 'lucide-react';
export function PlatformPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const features = [{
    icon: LayoutDashboard,
    title: 'Real-Time Dashboard',
    description: "Get a live feed of your restaurant's financial health. No more waiting for end-of-month reports."
  }, {
    icon: Zap,
    title: 'Automated Data Capture',
    description: 'Direct integration with your POS and accounting software eliminates manual entry errors.'
  }, {
    icon: ShieldCheck,
    title: 'Fraud Detection',
    description: 'AI-driven algorithms identify suspicious transactions and inventory discrepancies automatically.'
  }, {
    icon: BarChart3,
    title: 'Predictive Analytics',
    description: 'Forecast labor needs and food orders based on historical trends and upcoming events.'
  }, {
    icon: Database,
    title: 'Centralized Ledger',
    description: 'One source of truth for all your locations, vendors, and financial accounts.'
  }, {
    icon: Workflow,
    title: 'Custom Workflows',
    description: 'Tailor the platform to match your specific operational processes and approval chains.'
  }];
  return <main className="min-h-screen bg-stark-white" data-id="element-180">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-181" />

      <section className="pt-32 pb-20 bg-midnight-navy text-stark-white" data-id="element-182">
        <div className="max-w-7xl mx-auto px-6" data-id="element-183">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl" data-id="element-184">
            <h1 className="text-5xl md:text-6xl font-manrope font-bold mb-6" data-id="element-185">
              The ROI Platform
            </h1>
            <p className="text-xl text-stark-white/70 leading-relaxed" data-id="element-186">
              A comprehensive financial operating system built specifically for
              the complexities of modern restaurant management.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24" data-id="element-187">
        <div className="max-w-7xl mx-auto px-6" data-id="element-188">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-189">
            {features.map((feature, idx) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="space-y-4" data-id="element-190">
                <div className="w-12 h-12 bg-accent-red/10 rounded-lg flex items-center justify-center" data-id="element-191">
                  <feature.icon className="w-6 h-6 text-accent-red" data-id="element-192" />
                </div>
                <h3 className="text-xl font-manrope font-bold text-midnight-navy" data-id="element-193">
                  {feature.title}
                </h3>
                <p className="text-midnight-navy/60 leading-relaxed" data-id="element-194">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-195" />
      <Footer data-id="element-196" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-197" />
    </main>;
}